import { FeatureExposureType } from '@/components/intro-wizards/types';
import { useRedirectIfQuestionnaireUncompleted } from '@/hooks/use-redirect-if-questionnaire-uncompleted';
import {
  FeatureExposureStorageKey,
  useFeatureExposureCheck,
  useFeatureExposureMark,
} from '@/queries/feature-exposure.queries';
import { useGetTestingPlan } from '@/queries/testing-plan.queries';
import { useDisclosure } from '@cmpsr/components';
import { useEffect } from 'react';

export default function useTestingPlan() {
  const { isLoading: isLoadingTestingPlan } = useGetTestingPlan();
  const { isLoadingQuestionnaire } = useRedirectIfQuestionnaireUncompleted();

  const { data: hasBeenShown, isLoading: isLoadingFeatureCheck } = useFeatureExposureCheck(
    FeatureExposureType.testingPlan,
    FeatureExposureStorageKey.TestingPlan
  );
  const { mutate: markAsSeen } = useFeatureExposureMark(FeatureExposureType.testingPlan);
  const modalIntroWizardDisclosure = useDisclosure();

  useEffect(() => {
    if (hasBeenShown === false) {
      modalIntroWizardDisclosure.onOpen();
    } else {
      modalIntroWizardDisclosure.onClose();
    }
  }, [hasBeenShown, modalIntroWizardDisclosure]);

  function handleFinishIntroWizard() {
    markAsSeen();
    modalIntroWizardDisclosure.onClose();
  }

  const isLoading = isLoadingQuestionnaire || isLoadingTestingPlan || isLoadingFeatureCheck;

  return { isLoading, modalIntroWizardDisclosure, handleFinishIntroWizard };
}
